import React, { useState, useEffect } from 'react';
import { v4 } from 'uuid';
import ClassNames from 'classnames';
import { CarouselSnapped, CarouselSnappedSlide } from '@andes/carousel-snapped';
import { CarouselFree, CarouselFreeSlide } from '@andes/carousel-free';
import { CarouselSnappedControl, CarouselSnappedPagination } from '@andes-headless/carousel-snapped';
import { Typography, Image, Button as Button$1, Link, EshopsComponentsTitles } from '@mshops-components-library/common';
import { ChevronLeft, ChevronRight, ChevronBoldLeft, ChevronBoldRight, ArrowLeft, ArrowRight } from '@mshops-components-library/icons';
import { Button } from '@andes/button';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
var _ArrowLeft, _ArrowRight, _ChevronLeft, _ChevronRight, _ChevronBoldLeft, _ChevronBoldRight, _ChevronLeft2, _ChevronRight2;
var TYPES = {
  CHEVRON: 'chevron',
  BOLD_CHEVRON: 'bold_chevron',
  ARROW: 'arrow'
};
var getArrowsByType = function getArrowsByType(type) {
  switch (type) {
    case TYPES.ARROW:
      return {
        previous: _ArrowLeft || (_ArrowLeft = /*#__PURE__*/_createRawReactElement(ArrowLeft, {})),
        next: _ArrowRight || (_ArrowRight = /*#__PURE__*/_createRawReactElement(ArrowRight, {}))
      };
    case TYPES.CHEVRON:
      return {
        previous: _ChevronLeft || (_ChevronLeft = /*#__PURE__*/_createRawReactElement(ChevronLeft, {})),
        next: _ChevronRight || (_ChevronRight = /*#__PURE__*/_createRawReactElement(ChevronRight, {}))
      };
    case TYPES.BOLD_CHEVRON:
      return {
        previous: _ChevronBoldLeft || (_ChevronBoldLeft = /*#__PURE__*/_createRawReactElement(ChevronBoldLeft, {})),
        next: _ChevronBoldRight || (_ChevronBoldRight = /*#__PURE__*/_createRawReactElement(ChevronBoldRight, {}))
      };
    default:
      return {
        previous: _ChevronLeft2 || (_ChevronLeft2 = /*#__PURE__*/_createRawReactElement(ChevronLeft, {})),
        next: _ChevronRight2 || (_ChevronRight2 = /*#__PURE__*/_createRawReactElement(ChevronRight, {}))
      };
  }
};
var getOffsetByContent = function getOffsetByContent(isBackgroundArrow) {
  if (isBackgroundArrow) {
    return {
      previousOffsetX: -24,
      nextOffsetX: 24
    };
  }
  return {
    previousOffsetX: -40,
    nextOffsetX: 40
  };
};
var getPrice = function getPrice(price) {
  var regExp = /\d+([\\.\\,]*\d*)*/;
  return String(price).match(regExp)[0];
};
var zeroPrice = function zeroPrice(price) {
  if (!price) {
    return true;
  }
  var priceCleaned = getPrice(price);
  var regExp = /^[0]+([\\.\\,]*[0]*)*$/;
  return regExp.test(priceCleaned);
};
var BUTTON_VARIANT = {
  PRIMARY: 'primary',
  NEUTRAL: 'neutral'
};
var TEXT_LOCATION = {
  ABOVE: 'above',
  BELOW: 'below'
};
var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var BACKGROUND = {
  GRADIENT: 'gradient',
  TRANSPARENT: 'transparent'
};
var COLOR = {
  WHITE: 'white',
  ANDES_GRAY_900: '#1A1A1A',
  ANDES_GRAY_550: '#737373'
};
var NAMESPACE = 'carousel__item';
var BUTTON_TYPE = {
  STANDARD: 'standard'
};
var EXPLORER_THEME$1 = 'explorer';
var LEGEND_THEME$1 = 'legend';
var _path;
var Shape = function Shape() {
  return /*#__PURE__*/_createRawReactElement("svg", {
    style: {
      marginLeft: '7px'
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "15",
    viewBox: "0 0 7 13",
    fill: "none"
  }, void 0, _path || (_path = /*#__PURE__*/_createRawReactElement("path", {
    d: "M1.27735 0.723633L0.428824 1.57216L5.22445 6.36779L0.423828 11.1684L1.27236 12.0169L6.92151 6.36779L1.27735 0.723633Z",
    fill: "#F7F7F7"
  })));
};
var Shape$1 = Shape;
var EXPLORER_THEME = 'explorer';
var LEGEND_THEME = 'legend';
var SELLER_THEME = 'seller';
var LANDING_ESHOP = 'landing';
var CAROUSEL_FULL = 'full';
var CAROUSEL_CONTENT = 'content';
var CAROUSEL_COLUMNS_1 = 1;
var CAROUSEL_COLUMNS_2 = 2;
var CAROUSEL_COLUMNS_3 = 3;
var CAROUSEL_COLUMNS_4 = 4;
var CAROUSEL_COLUMNS_10 = 10;
var ONE_CAROUSEL_ITEMS = 1;
var DEVICE_MOBILE = 'mobile';
var _Shape, _div2;
var replaceExtension = function replaceExtension(url) {
  var regex = /(\.(?!svg|webp$)[a-zA-Z0-9]+)$/i;
  return url === null || url === void 0 ? void 0 : url.replace(regex, '.webp');
};
var CategoryCard = function CategoryCard(_ref) {
  var _div, _span, _div3;
  var label = _ref.label,
    image = _ref.image,
    showPrice = _ref.showPrice,
    showButton = _ref.showButton,
    showCategoryTitle = _ref.showCategoryTitle,
    isRoundImage = _ref.isRoundImage,
    isFixedHeight = _ref.isFixedHeight,
    title = _ref.title,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? '' : _ref$price,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
    _ref$link = _ref.link,
    _ref$link2 = _ref$link === void 0 ? {} : _ref$link,
    url = _ref$link2.url,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 2 : _ref$columns,
    _ref$pricePrefix = _ref.pricePrefix,
    pricePrefix = _ref$pricePrefix === void 0 ? '' : _ref$pricePrefix,
    isEmpty = _ref.isEmpty,
    originalImage = _ref.originalImage,
    emptyStateCard = _ref.emptyStateCard,
    _ref$isEshops = _ref.isEshops,
    isEshops = _ref$isEshops === void 0 ? false : _ref$isEshops,
    _ref$isCustomHtml = _ref.isCustomHtml,
    isCustomHtml = _ref$isCustomHtml === void 0 ? false : _ref$isCustomHtml,
    _ref$textLocation = _ref.textLocation,
    textLocation = _ref$textLocation === void 0 ? 'left' : _ref$textLocation,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'transparent' : _ref$background,
    _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? 'standard' : _ref$buttonType,
    _ref$elements_alignme = _ref.elements_alignment,
    elements_alignment = _ref$elements_alignme === void 0 ? 'left' : _ref$elements_alignme,
    theme = _ref.theme,
    trackingId = _ref.trackingId;
  var carouselItem = ClassNames("".concat(NAMESPACE), ["".concat(NAMESPACE, "--text-").concat(textLocation), "".concat(NAMESPACE, "--background-").concat(background), "".concat(NAMESPACE, "--button-").concat(buttonType), "".concat(NAMESPACE, "--elements-").concat(elements_alignment)], _defineProperty({}, "".concat(NAMESPACE, "--2"), columns === 2), _defineProperty({}, "".concat(NAMESPACE, "--3"), columns === 3), _defineProperty({}, "".concat(NAMESPACE, "--4"), columns === 4), _defineProperty({}, "".concat(NAMESPACE, "--10"), columns === 10), _defineProperty({}, "".concat(NAMESPACE, "-fixed-height"), isFixedHeight));
  var carouselItemImage = ClassNames("".concat(NAMESPACE, "-image"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(NAMESPACE, "-image-2"), columns === 2), "".concat(NAMESPACE, "-image-3"), columns === 3), "".concat(NAMESPACE, "-image-4"), columns === 4), "".concat(NAMESPACE, "-image-10"), columns === 10), "".concat(NAMESPACE, "-image-empty"), isEmpty), "".concat(NAMESPACE, "-image-default"), image === originalImage), "".concat(NAMESPACE, "-image-round"), isRoundImage), "".concat(NAMESPACE, "-fixed-height"), isFixedHeight));
  var addTrackUrl = function addTrackUrl(baseUrl) {
    var encodedPlaceholder = '%7Btracking_id%7D';
    var encodedTrackingId = encodeURIComponent(trackingId);
    return (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.replace(encodedPlaceholder, encodedTrackingId)) || baseUrl || '';
  };
  var trackedUrl = addTrackUrl(url);
  var isEshopsOrCustomHTML = isEshops || isCustomHtml;
  var renderPrice = function renderPrice() {
    var isPriceInvdalid = isEshops && zeroPrice(price);
    if (isPriceInvdalid) {
      return null;
    }
    return isCustomHtml ? _div || (_div = /*#__PURE__*/_createRawReactElement("div", {
      className: "carousel__item-foot-subtitle"
    }, void 0, /*#__PURE__*/_createRawReactElement("span", {}, void 0, pricePrefix), " ", /*#__PURE__*/_createRawReactElement("span", {}, void 0, price))) : /*#__PURE__*/_createRawReactElement(Typography, {
      className: "".concat(NAMESPACE, "-foot-subtitle"),
      type: "body",
      size: SIZE.SMALL,
      weight: "regular",
      color: textLocation === TEXT_LOCATION.ABOVE ? COLOR.WHITE : COLOR.ANDES_GRAY_550
    }, void 0, pricePrefix, " ", price);
  };
  var buttonVariant = textLocation === TEXT_LOCATION.BELOW ? BUTTON_VARIANT.PRIMARY : BUTTON_VARIANT.NEUTRAL;
  var renderLink = function renderLink() {
    if (isEshopsOrCustomHTML) {
      return /*#__PURE__*/_createRawReactElement("div", {
        className: "".concat(NAMESPACE, "-foot-link")
      }, void 0, _span || (_span = /*#__PURE__*/_createRawReactElement("span", {}, void 0, buttonText)));
    }
    return /*#__PURE__*/_createRawReactElement(Link, {
      href: trackedUrl,
      text: buttonText,
      isSpan: true,
      className: "".concat(NAMESPACE, "-foot-link")
    });
  };
  var renderButton = function renderButton() {
    if (isCustomHtml || isEshops && buttonType === BUTTON_TYPE.STANDARD) {
      return /*#__PURE__*/_createRawReactElement("div", {
        className: "".concat(NAMESPACE, "-foot-button")
      }, void 0, /*#__PURE__*/_createRawReactElement(Button, {
        hierarchy: isEshops ? "quiet" : "loud",
        size: isEshops ? "small" : "large"
      }, void 0, buttonText, theme === LEGEND_THEME && (_Shape || (_Shape = /*#__PURE__*/_createRawReactElement(Shape$1, {})))));
    }
    return buttonType !== BUTTON_TYPE.STANDARD ? renderLink() : /*#__PURE__*/_createRawReactElement("div", {
      className: "".concat(NAMESPACE, "-foot-button")
    }, void 0, /*#__PURE__*/_createRawReactElement(Button$1, {
      cta: buttonText,
      variant: buttonVariant,
      size: SIZE.MEDIUM,
      href: trackedUrl,
      isSpan: true
    }));
  };
  var carouselItemImageBackground = ClassNames("".concat(NAMESPACE, "-image-background"), _defineProperty(_defineProperty({}, "".concat(NAMESPACE, "-image-background--gradient"), background === BACKGROUND.GRADIENT), "".concat(NAMESPACE, "-image-background--transparent"), background === BACKGROUND.TRANSPARENT));
  var renderImageBackground = function renderImageBackground() {
    if (isCustomHtml) {
      return (theme === LEGEND_THEME || theme === EXPLORER_THEME) && (_div2 || (_div2 = /*#__PURE__*/_createRawReactElement("div", {
        className: "carousel__item-image-background"
      })));
    }
    return textLocation === TEXT_LOCATION.ABOVE && (_div3 || (_div3 = /*#__PURE__*/_createRawReactElement("div", {
      className: carouselItemImageBackground
    })));
  };
  return /*#__PURE__*/_createRawReactElement("a", {
    className: carouselItem,
    href: trackedUrl
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: carouselItemImage
  }, void 0, renderImageBackground(), /*#__PURE__*/_createRawReactElement(Image, {
    className: "".concat(NAMESPACE, "-image-content"),
    src: replaceExtension(image) || replaceExtension(emptyStateCard === null || emptyStateCard === void 0 ? void 0 : emptyStateCard.image_src),
    alt: label
  })), showCategoryTitle && /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(NAMESPACE, "-foot ").concat(NAMESPACE, "-foot--").concat(elements_alignment)
  }, void 0, isCustomHtml ? /*#__PURE__*/_createRawReactElement("h2", {
    className: "".concat(NAMESPACE, "-foot-title")
  }, void 0, title) : /*#__PURE__*/_createRawReactElement(Typography, {
    className: "".concat(NAMESPACE, "-foot-title"),
    type: "body",
    size: SIZE.MEDIUM,
    weight: "semibold",
    color: textLocation === TEXT_LOCATION.ABOVE ? COLOR.WHITE : COLOR.ANDES_GRAY_900
  }, void 0, title), showPrice && renderPrice(), showButton && renderButton()));
};
var CategoryCard$1 = CategoryCard;
var useCategoriesCarousel = function useCategoriesCarousel(_ref) {
  var columns = _ref.columns,
    isEmpty = _ref.isEmpty,
    categories = _ref.categories,
    deviceType = _ref.deviceType,
    layoutTheme = _ref.layoutTheme,
    showPrice = _ref.show_price,
    showButton = _ref.show_button,
    showCategoryTitle = _ref.show_category_title,
    isRoundImage = _ref.is_round_image,
    isFixedHeight = _ref.is_fixed_height,
    buttonText = _ref.button_text,
    pricePrefix = _ref.price_prefix,
    emptyStateCard = _ref.empty_state_card,
    textLocation = _ref.textLocation,
    background = _ref.background,
    buttonType = _ref.buttonType,
    elements_alignment = _ref.elements_alignment;
  var getNewSlide = function getNewSlide(newCategories) {
    return newCategories.map(function (_ref2) {
      var _images$deviceType;
      var label = _ref2.label,
        CategoryName = _ref2.category_name,
        price = _ref2.price,
        imageSrc = _ref2.image_src,
        images = _ref2.images,
        link = _ref2.link,
        isDefaultImage = _ref2.is_default_image,
        originalImage = _ref2.original_image;
      return {
        label: label,
        title: CategoryName,
        subTitle: price,
        image: (images === null || images === void 0 || (_images$deviceType = images[deviceType]) === null || _images$deviceType === void 0 ? void 0 : _images$deviceType.source) || imageSrc,
        link: link,
        price: price,
        isDefaultImage: isDefaultImage,
        buttonText: buttonText,
        pricePrefix: pricePrefix,
        showPrice: showPrice,
        showButton: showButton,
        showCategoryTitle: showCategoryTitle,
        isRoundImage: isRoundImage,
        isFixedHeight: isFixedHeight,
        deviceType: deviceType,
        columns: columns,
        theme: layoutTheme,
        isEmpty: isEmpty,
        emptyStateCard: emptyStateCard,
        originalImage: originalImage,
        textLocation: textLocation,
        background: background,
        buttonType: buttonType,
        elements_alignment: elements_alignment
      };
    });
  };
  var slides = getNewSlide(categories);
  var _useState = useState(slides),
    _useState2 = _slicedToArray(_useState, 2),
    slidesCategories = _useState2[0],
    setSlidesCategories = _useState2[1];
  useEffect(function () {
    setSlidesCategories(slides);
  }, [categories, buttonText, showButton, showPrice, columns]);
  return {
    slidesCategories: slidesCategories
  };
};
var useCategoriesCarousel$1 = useCategoriesCarousel;
var _svg$5;
var ArrowLeftLegend = function ArrowLeftLegend() {
  return _svg$5 || (_svg$5 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "12",
    height: "26",
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M1.64092e-06 12.9998L0.510303 13.6064L10.5576 25.5L12 24.2872L2.46296 13L12 1.71278L10.5576 0.500001L0.510303 12.3936L1.64088e-06 13.0002L1.64092e-06 12.9998Z",
    fill: "#232732"
  })));
};
var _svg$4;
var ArrowRightLegend = function ArrowRightLegend() {
  return _svg$4 || (_svg$4 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "12",
    height: "26",
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M12 13.0002L11.4897 12.3936L1.44244 0.5L9.00495e-07 1.71278L9.53704 13L-8.93746e-08 24.2872L1.44244 25.5L11.4897 13.6064L12 12.9998L12 13.0002Z",
    fill: "#232732"
  })));
};
var _svg$3;
var ArrowLeftExplorer = function ArrowLeftExplorer() {
  return _svg$3 || (_svg$3 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "18",
    height: "15",
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M0.260529 8.1173L5.79868 14.47C6.15532 14.9035 6.86015 14.9422 7.2735 14.5648C7.68684 14.1874 7.72865 13.4675 7.34545 13.0584L3.34325 8.47028H16.9615C17.5349 8.47028 18 7.99614 18 7.41144C18 6.82674 17.5352 6.35259 16.9615 6.35259H3.34325L7.34545 1.76448C7.72865 1.35532 7.67698 0.636684 7.26336 0.259304C6.84998 -0.118095 6.15528 -0.0806721 5.79868 0.352855L0.260529 6.70554C-0.101181 7.21908 -0.0722028 7.68019 0.260529 8.11713V8.1173Z",
    fill: "#737373"
  }), /*#__PURE__*/_createRawReactElement("path", {
    d: "M0.260529 8.1173L5.79868 14.47C6.15532 14.9035 6.86015 14.9422 7.2735 14.5648C7.68684 14.1874 7.72865 13.4675 7.34545 13.0584L3.34325 8.47028H16.9615C17.5349 8.47028 18 7.99614 18 7.41144C18 6.82674 17.5352 6.35259 16.9615 6.35259H3.34325L7.34545 1.76448C7.72865 1.35532 7.67698 0.636684 7.26336 0.259304C6.84998 -0.118095 6.15528 -0.0806721 5.79868 0.352855L0.260529 6.70554C-0.101181 7.21908 -0.0722028 7.68019 0.260529 8.11713V8.1173Z",
    fill: "#737373"
  })));
};
var _svg$2;
var ArrowRightExplorer = function ArrowRightExplorer() {
  return _svg$2 || (_svg$2 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "18",
    height: "15",
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M17.7395 6.8827L12.2013 0.530014C11.8447 0.0964872 11.1399 0.057835 10.7265 0.435234C10.3132 0.812633 10.2713 1.53246 10.6545 1.9416L14.6567 6.52972L1.03853 6.52972C0.465069 6.52972 1.55258e-07 7.00386 1.55258e-07 7.58856C1.55258e-07 8.17326 0.464809 8.64741 1.03853 8.64741L14.6567 8.64741L10.6545 13.2355C10.2713 13.6447 10.323 14.3633 10.7366 14.7407C11.15 15.1181 11.8447 15.0807 12.2013 14.6471L17.7395 8.29446C18.1012 7.78092 18.0722 7.31981 17.7395 6.88287V6.8827Z",
    fill: "#737373"
  }), /*#__PURE__*/_createRawReactElement("path", {
    d: "M17.7395 6.8827L12.2013 0.530014C11.8447 0.0964872 11.1399 0.057835 10.7265 0.435234C10.3132 0.812633 10.2713 1.53246 10.6545 1.9416L14.6567 6.52972L1.03853 6.52972C0.465069 6.52972 1.55258e-07 7.00386 1.55258e-07 7.58856C1.55258e-07 8.17326 0.464809 8.64741 1.03853 8.64741L14.6567 8.64741L10.6545 13.2355C10.2713 13.6447 10.323 14.3633 10.7366 14.7407C11.15 15.1181 11.8447 15.0807 12.2013 14.6471L17.7395 8.29446C18.1012 7.78092 18.0722 7.31981 17.7395 6.88287V6.8827Z",
    fill: "#737373"
  })));
};
var _svg$1;
var ArrowRightMaterial = function ArrowRightMaterial() {
  return _svg$1 || (_svg$1 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M13.0588 4.9375L10.9375 7.05882L19.8768 15.9982L10.9375 24.9375L13.0588 27.0588L24.1195 15.9982L13.0588 4.9375Z",
    fill: "#3483FA"
  })));
};
var _svg;
var ArrowLeftMaterial = function ArrowLeftMaterial() {
  return _svg || (_svg = /*#__PURE__*/_createRawReactElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M21.0599 24.9395L12.1206 16.0001L21.0599 7.06077L18.9386 4.93945L7.87793 16.0001L18.9386 27.0608L21.0599 24.9395Z",
    fill: "#3483FA"
  })));
};
var _ArrowLeftExplorer, _ArrowRightExplorer, _ArrowLeftLegend, _ArrowRightLegend, _ArrowLeftMaterial, _ArrowRightMaterial;
var getArrowsByTheme = function getArrowsByTheme(theme) {
  switch (theme) {
    case EXPLORER_THEME$1:
      return {
        previous: _ArrowLeftExplorer || (_ArrowLeftExplorer = /*#__PURE__*/_createRawReactElement(ArrowLeftExplorer, {})),
        next: _ArrowRightExplorer || (_ArrowRightExplorer = /*#__PURE__*/_createRawReactElement(ArrowRightExplorer, {})),
        previousOffsetX: -32,
        nextOffsetX: 32
      };
    case LEGEND_THEME$1:
      return {
        previous: _ArrowLeftLegend || (_ArrowLeftLegend = /*#__PURE__*/_createRawReactElement(ArrowLeftLegend, {})),
        next: _ArrowRightLegend || (_ArrowRightLegend = /*#__PURE__*/_createRawReactElement(ArrowRightLegend, {})),
        previousOffsetX: -57,
        nextOffsetX: 57
      };
    default:
      return {
        previous: _ArrowLeftMaterial || (_ArrowLeftMaterial = /*#__PURE__*/_createRawReactElement(ArrowLeftMaterial, {})),
        next: _ArrowRightMaterial || (_ArrowRightMaterial = /*#__PURE__*/_createRawReactElement(ArrowRightMaterial, {})),
        previousOffsetX: 0,
        nextOffsetX: 0
      };
  }
};
const CategoriesCarousel = /*#__PURE__*/function () {
  const CategoriesCarousel = function CategoriesCarousel(_ref) {
    var _h, _Typography, _p, _EshopsComponentsTitl;
    var title = _ref.title,
      columns = _ref.columns,
      isEmpty = _ref.isEmpty,
      categories = _ref.categories,
      deviceType = _ref.deviceType,
      layoutTheme = _ref.layoutTheme,
      subTitle = _ref.sub_title,
      showTitle = _ref.show_title,
      showPrice = _ref.show_price,
      showButton = _ref.show_button,
      showCategoryTitle = _ref.show_category_title,
      isRoundImage = _ref.is_round_image,
      isFixedHeight = _ref.is_fixed_height,
      buttonText = _ref.button_text,
      pricePrefix = _ref.price_prefix,
      showSubTitle = _ref.show_sub_title,
      emptyStateCard = _ref.empty_state_card,
      isEshops = _ref.isEshops,
      eshopType = _ref.eshopType,
      isFreeCarousel = _ref.isFreeCarousel,
      _ref$isCustomHtml = _ref.isCustomHtml,
      isCustomHtml = _ref$isCustomHtml === void 0 ? false : _ref$isCustomHtml,
      text_alignment = _ref.text_alignment,
      elements_alignment = _ref.elements_alignment,
      custom_styles = _ref.custom_styles,
      globalConfig = _ref.globalConfig,
      trackingId = _ref.trackingId;
    var navigationPagination = custom_styles.navigation_pagination,
      arrow = custom_styles.arrow,
      textLocation = custom_styles.text_location,
      background = custom_styles.background,
      buttonType = custom_styles.button_design;
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      safariBrowser = _useState2[0],
      setSafariBrowser = _useState2[1];
    var _useCategoriesCarouse = useCategoriesCarousel$1({
        title: title,
        columns: columns,
        isEmpty: isEmpty,
        categories: categories,
        deviceType: deviceType,
        layoutTheme: layoutTheme,
        sub_title: subTitle,
        show_title: showTitle,
        show_price: showPrice,
        show_button: showButton,
        show_category_title: showCategoryTitle,
        is_round_image: isRoundImage,
        is_fixed_height: isFixedHeight,
        button_text: buttonText,
        price_prefix: pricePrefix,
        show_sub_title: showSubTitle,
        empty_state_card: emptyStateCard,
        textLocation: textLocation,
        background: background,
        buttonType: buttonType,
        elements_alignment: elements_alignment
      }),
      slidesCategories = _useCategoriesCarouse.slidesCategories;
    var isMobile = deviceType === DEVICE_MOBILE;
    var column = isMobile || categories.length === ONE_CAROUSEL_ITEMS ? CAROUSEL_COLUMNS_1 : columns;
    var isEshopsOrCustomHTML = isEshops || isCustomHtml;
    var isExplorer = layoutTheme === EXPLORER_THEME && !isEshops;
    var isLegend = layoutTheme === LEGEND_THEME && !isEshops;
    var isClassic = !isExplorer && !isLegend && !isEshops;
    var sizeBasedOnDevice = isMobile ? 'small' : 'medium';
    var isNewImages = isEshops;
    var carouselContainer = ClassNames("carousel__container carousel__container--".concat(deviceType), {
      'carousel__container-2': columns === CAROUSEL_COLUMNS_2,
      'carousel__container-3': columns === CAROUSEL_COLUMNS_3,
      'carousel__container-4': columns === CAROUSEL_COLUMNS_4,
      'carousel__container-10': columns === CAROUSEL_COLUMNS_10,
      'carousel__container-1': (categories === null || categories === void 0 ? void 0 : categories.length) === CAROUSEL_COLUMNS_1,
      'carousel__container--explorer': isExplorer,
      'carousel__container--legend': isLegend,
      'carousel__container--classic': isClassic,
      'carousel__container--new': isNewImages,
      'safari': safariBrowser
    });
    var freeCarouselContainer = ClassNames('free-carousel__container', {
      'carousel__container-3': columns === CAROUSEL_COLUMNS_3
    }, {
      'carousel__container-4': columns === CAROUSEL_COLUMNS_4
    }, {
      'carousel__container-10': columns === CAROUSEL_COLUMNS_10
    }, {
      'carousel__container--fixed-height': isFixedHeight
    });
    var classCarousel = ClassNames('carousel__container-body ui-ms-component-catogories-carousel', {});
    var bodyHeaderClass = ClassNames("carousel__container-body-header", _defineProperty({
      'carousel__container-body-header--landing': eshopType === LANDING_ESHOP && layoutTheme === SELLER_THEME
    }, "carousel__container-body-header--".concat(textLocation), textLocation));
    var titleClass = ClassNames("carousel__container-title", _defineProperty({}, "carousel__container-title--".concat(text_alignment), text_alignment));
    var subtitleClass = ClassNames("carousel__container-subtitle", _defineProperty({}, "carousel__container-subtitle--".concat(text_alignment), text_alignment));
    var renderTitle = function renderTitle() {
      if (isCustomHtml) {
        return _h || (_h = /*#__PURE__*/_createRawReactElement("h2", {
          className: "carousel__container-body-header-title"
        }, void 0, title));
      }
      return _Typography || (_Typography = /*#__PURE__*/_createRawReactElement(Typography, {
        type: "title",
        weight: "bold",
        size: sizeBasedOnDevice,
        className: titleClass
      }, void 0, title));
    };
    var eshopsSizeBasedOnDevice = isMobile ? 'small' : 'large';
    var renderSubtitle = function renderSubtitle() {
      if (isCustomHtml) {
        return _p || (_p = /*#__PURE__*/_createRawReactElement("p", {
          className: "carousel__container-body-header-subtitle"
        }, void 0, subTitle));
      }
      return /*#__PURE__*/_createRawReactElement(Typography, {
        type: "body",
        size: isEshops ? eshopsSizeBasedOnDevice : "medium",
        className: subtitleClass
      }, void 0, subTitle);
    };
    var showTitles = function showTitles() {
      return typeEshop(eshopType) ? _EshopsComponentsTitl || (_EshopsComponentsTitl = /*#__PURE__*/_createRawReactElement(EshopsComponentsTitles, {
        title: title,
        subtitle: subTitle,
        showTitle: showTitle,
        showSubTitle: showSubTitle,
        deviceType: deviceType,
        titleClassName: titleClass,
        subtitleClassName: subtitleClass
      })) : /*#__PURE__*/_createRawReactElement("div", {
        className: bodyHeaderClass
      }, void 0, showTitle && renderTitle(), showSubTitle && renderSubtitle());
    };
    var _useState3 = useState(slidesCategories),
      _useState4 = _slicedToArray(_useState3, 2),
      categoriesItems = _useState4[0],
      setCategoriesItems = _useState4[1];
    var CustomArrow = function CustomArrow(renderProps) {
      var arrowType = renderProps.type,
        disabled = renderProps.disabled;
      var namespaceArrow = 'ui-ms-categories-carousel-control';
      var navigationControlClassnames = ClassNames(namespaceArrow, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(namespaceArrow, "--").concat(arrowType), arrowType), "".concat(namespaceArrow, "--disabled"), disabled), "".concat(namespaceArrow, "--").concat(layoutTheme), layoutTheme), "".concat(namespaceArrow, "--background"), arrow.background), "".concat(namespaceArrow, "--empty"), !arrow.background));
      var getArrow = function getArrow() {
        var _globalConfig$arrow;
        if (isCustomHtml) {
          return getArrowsByTheme(layoutTheme)[arrowType];
        }
        return getArrowsByType(globalConfig === null || globalConfig === void 0 || (_globalConfig$arrow = globalConfig.arrow) === null || _globalConfig$arrow === void 0 ? void 0 : _globalConfig$arrow.icon)[arrowType];
      };
      return /*#__PURE__*/React.createElement(CarouselSnappedControl, _extends({
        className: navigationControlClassnames,
        type: arrowType
      }, renderProps), getArrow());
    };
    var CustomPagination = function CustomPagination(renderProps) {
      var namespacePagination = 'ui-ms-categories-carousel-pagination';
      var paginationClassnames = ClassNames(namespacePagination, _defineProperty({}, "".concat(namespacePagination, "--").concat(navigationPagination), navigationPagination));
      return /*#__PURE__*/React.createElement(CarouselSnappedPagination, _extends({
        className: paginationClassnames
      }, renderProps));
    };
    var getOffset = function getOffset() {
      if (isCustomHtml) {
        return getArrowsByTheme(layoutTheme);
      }
      return getOffsetByContent(arrow.background);
    };
    var arrowConfig = isEshopsOrCustomHTML ? true : {
      previous: {
        component: CustomArrow,
        position: 'left',
        offsetX: getOffset().previousOffsetX
      },
      next: {
        component: CustomArrow,
        position: 'right',
        offsetX: getOffset().nextOffsetX
      },
      visibility: "always"
    };
    var CONFIG_BY_DEVICE = {
      CAROUSEL: {
        desktop: {
          slidesPerView: column,
          thresholdSlide: 0,
          spacing: isCustomHtml ? 24 : 16,
          type: isCustomHtml ? CAROUSEL_FULL : CAROUSEL_CONTENT,
          arrows: arrowConfig
        },
        mobile: {
          slidesPerView: 1,
          thresholdSlide: 3,
          type: CAROUSEL_CONTENT,
          arrows: false,
          spacing: 0
        }
      }
    };
    useEffect(function () {
      setCategoriesItems(slidesCategories);
    }, [slidesCategories]);
    useEffect(function () {
      var _window;
      var userAgent = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 || (_window = _window.userAgent) === null || _window === void 0 ? void 0 : _window.toLowerCase();
      var isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      if (isSafari) {
        setSafariBrowser(true);
      }
    }, []);
    var isEshopsOrCustomHtml = isEshops || isCustomHtml;
    var paginationConfig = isEshopsOrCustomHtml ? false : {
      custom: {
        component: CustomPagination,
        offsetY: 32
      }
    };
    var snapCategoryCarousel = function snapCategoryCarousel() {
      return /*#__PURE__*/_createRawReactElement("article", {
        className: carouselContainer
      }, void 0, /*#__PURE__*/_createRawReactElement("div", {
        className: classCarousel
      }, void 0, showTitles(), slidesCategories && /*#__PURE__*/React.createElement(CarouselSnapped, _extends({
        extend: true,
        srLabel: title,
        pagination: paginationConfig
      }, CONFIG_BY_DEVICE.CAROUSEL[deviceType], {
        className: "carousel-snapped__wrapper"
      }), categoriesItems.map(function (item) {
        return /*#__PURE__*/_createRawReactElement(CarouselSnappedSlide, {
          pagination: paginationConfig
        }, v4(), /*#__PURE__*/React.createElement(CategoryCard$1, _extends({}, item, {
          position: item.position,
          deviceType: deviceType,
          isEshops: isEshops,
          isCustomHtml: isCustomHtml,
          theme: layoutTheme,
          trackingId: trackingId
        })));
      }))));
    };
    var freeCategoryCarousel = function freeCategoryCarousel() {
      return /*#__PURE__*/_createRawReactElement("article", {
        className: freeCarouselContainer
      }, void 0, /*#__PURE__*/_createRawReactElement("div", {
        className: classCarousel
      }, void 0, showTitles(), slidesCategories && /*#__PURE__*/_createRawReactElement(CarouselFree, {}, void 0, categoriesItems.map(function (item) {
        return /*#__PURE__*/_createRawReactElement(CarouselFreeSlide, {}, v4(), /*#__PURE__*/React.createElement(CategoryCard$1, _extends({}, item, {
          position: item.position,
          deviceType: deviceType,
          isEshops: isEshops,
          isCustomHtml: isCustomHtml,
          theme: layoutTheme,
          trackingId: trackingId
        })));
      }))));
    };
    return isFreeCarousel && isMobile ? freeCategoryCarousel() : snapCategoryCarousel();
  };
  CategoriesCarousel.defaultProps = {
    title: '',
    sub_title: '',
    children: [],
    show_title: true,
    show_sub_title: true,
    show_price: true,
    show_button: true,
    isEmpty: false,
    isEshops: false,
    show_category_title: true,
    is_round_image: false,
    is_fixed_height: false
  };
  return CategoriesCarousel;
}();
var CategoriesCarousel$1 = CategoriesCarousel;
export { CategoriesCarousel$1 as CategoriesCarousel, CategoriesCarousel$1 as default };
